var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.user.isAdmin
    ? _c("div", [
        _c("div", { staticClass: "flex flex-wrap flex-col md:flex-row" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "w-full md:w-1/2 md:text-right mb-5 md:mb-0" },
            [
              _c(
                "a",
                {
                  staticClass: "button mb-12",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.syncOrganizations.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("Sync Organizations")]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex flex-wrap" }, [
          _c("div", { staticClass: "flex-1 mb-3" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.keyword,
                  expression: "keyword",
                },
              ],
              staticClass: "mb-4 search",
              attrs: {
                type: "text",
                placeholder: "Search for organization name",
              },
              domProps: { value: _vm.keyword },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.searchOrganizations.apply(null, arguments)
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.keyword = $event.target.value
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "w-full md:w-1/5" }, [
            _c(
              "button",
              {
                staticClass: "button mb-2",
                attrs: { href: "/events/create" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.searchOrganizations.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Search")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "w-full md:w-1/5" }, [
            _c(
              "button",
              {
                staticClass: "button mb-2",
                attrs: { href: "/events/create" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.clearSearch.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Clear")]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "responsive-table" }, [
          _c(
            "table",
            { staticClass: "w-full" },
            [
              _vm._m(1),
              _vm._v(" "),
              this.isSearching && this.searchedOrganizations.length < 1
                ? _c("tr", [
                    _c(
                      "td",
                      {
                        staticClass: "text-center font-bold",
                        attrs: { colspan: "5" },
                      },
                      [_vm._v("No search results")]
                    ),
                  ])
                : _vm._l(_vm.filteredOrganizations, function (organization) {
                    return _c("organization-item", {
                      key: organization.id,
                      attrs: { organization: organization },
                    })
                  }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex mt-8" }, [
          _c("div", { staticClass: "w-1/2" }, [
            _c(
              "button",
              {
                staticClass: "mt-2",
                class: {
                  "opacity-50 cursor-not-allowed": _vm.currentPage === 1,
                },
                attrs: { disabled: _vm.currentPage === 1 },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.previous.apply(null, arguments)
                  },
                },
              },
              [_vm._v("<< Previous")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "w-1/2 text-right" }, [
            _c(
              "button",
              {
                staticClass: "mt-2",
                class: {
                  "opacity-50 cursor-not-allowed":
                    _vm.currentPage === _vm.totalPages,
                },
                attrs: { disabled: _vm.currentPage === _vm.totalPages },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.next.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Next >>")]
            ),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-full md:w-1/2" }, [
      _c(
        "h1",
        { staticClass: "mt-2 mb-4 md:mb-0 font-sans text-n-gray-dark" },
        [_vm._v("Organizations")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Organization")]),
        _vm._v(" "),
        _c("th", [_vm._v("Url")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }